module.exports = __webpack_public_path__ + "img/partner2.4aa3f8c1.png";